import React from 'react';
import LandingPagePhotoToPDFModal from 'LandingPagePhotoToPDFModal';
import EditPDFLandingPageRadioButtons from './EditPDFLandingPageRadioButtons';

const EditPDFLandingPageLargeUploadPanel = () => (
  <div className="span6">
    <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
      <form id="dropzoneUploader" className="uploader">
        <div className="alert alert-error uploader-error">Error</div>
        <a
          id="uploadPDFLargeMobile"
          className="btn btn-custom_info is-block is-big is-hidden"
        >
          Select a file to Upload
        </a>
        <div
          className="uploader-area edit-pages-uploader-area"
          onDrop={window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone')}
        >
          <img
            src="/images/document-and-arrow-icon.png"
            alt="Document and Arrow Icon"
            className="large-upload-panel-document-icon"
          />
          <h3 className="large-upload-panel-header">Drag and Drop Your File Here</h3>
          <p className="large-upload-panel-sub-header">PDF or Word Document</p>
          <EditPDFLandingPageRadioButtons />
          <a
            id="uploadPDFLarge"
            className="btn btn-success large-upload-panel-cta-button"
          >
            Upload a File to Edit
          </a>
        </div>
      </form>
    </div>
    <LandingPagePhotoToPDFModal />
  </div>
);

export default EditPDFLandingPageLargeUploadPanel;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageLargeUploadPanel.jsx